import { getPopularSearch, getQuickSearch } from "@repo/server-actions/search";
import { useLocale } from "next-intl";
import { useCallback, useState, useTransition } from "react";

const useMiniSearch = () => {
  const locale = useLocale();
  const [popuparSearch, setPopuparSearch] = useState(null);
  const [quickSearch, setQuickSearch] = useState(null);
  const [isPending, startTransition] = useTransition();

  const handlePopularSearch = useCallback(async () => {
    startTransition(async () => {
      const response = await getPopularSearch(locale);
      setPopuparSearch(response);
    });
  }, [setPopuparSearch, locale]);

  const handleQuickSearch = useCallback(
    async (term) => {
      startTransition(async () => {
        const response = await getQuickSearch(term, locale);
        setQuickSearch(response);
      });
    },
    [setQuickSearch, locale]
  );

  return {
    handlePopularSearch,
    handleQuickSearch,
    popuparSearch,
    quickSearch,
    isPending,
  };
};

export default useMiniSearch;
